import React from 'react'
import { useState } from 'react';
import { Row, Col, Button } from "react-bootstrap";
import Icon from '../../component/Icon/Icon';
import { ModalMessage } from '../../component/Modal/ModalMessage';
import DispositionService from '../../disposition/DipositionService';
import Notify from '../../services/Notify';
import ModalMessageNew from "../../component/Modal/ModalMessageNew";

class DispositionsGrid {

  constructor () {
    this.dispositionsService = new DispositionService()
  }

  title = "Disposições";

  exportNewPage = true;

  showPdfButton = false;

  columns = [
    {
      Header: 'Nome',
      accessor: 'friendlyName',
      HeaderColumn: true,
    },
    {
      Header: 'Descrição',
      accessor: 'description',
    },
    {
      Header: 'Ultimo estado',
      accessor: 'lastAssetState',
    },
    {
      Header: "Código ERP",
      accessor: "erpCode"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => {
        const [showModal, setShowModal] = useState(false)

         const deleteDispositionById = async (dispositionId) => {
          try {
            await  this.dispositionsService.deleteById(dispositionId)
            this.forceReload()
            Notify.success("Disposição deletada com sucesso!")
          } catch (error) {
            Notify.error("Houve um erro ao deletar a disposição, por favor tente novamente em alguns instantes.", error)
          } finally {
            setShowModal(false)
          }
         }
        const handleShowModal = () => setShowModal(!showModal)
        return (
          <Row className="justify-content-around">
            <Col sm={6}>
              <Button title="Editar" bsStyle="success" block href={"#/dispositions/" + row.original.id + "/edit"}>
                <Icon icon='pencil' />
              </Button>
            </Col>
            <Col sm={6}>
              <Button title="Excluir" onClick={handleShowModal} bsStyle="danger" block>
                <Icon icon='trash' />
              </Button>
            </Col>
            <ModalMessageNew
              title={`Tem certeza que deseja excluir a disposição ${row.original.friendlyName} ?`}
              errorButtonAction={handleShowModal}
              handleShowModal={handleShowModal}
              successButtonAction={() =>deleteDispositionById(row.original.id)}
              showModal={showModal}
            />
          </Row>
        )
      }
    }
  ]

  endpoint = () => {
    return `ton/v1/dispositions`;
  };

}

export default DispositionsGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/DispositionsGrid.js